module.exports = __webpack_public_path__ + "static/media/vivo-logo-new.50055752.svg";